import { Sun, Moon } from 'lucide-react';
import { useAppStore } from '../../store/useAppStore';

/** Sichtbare Hell/Dunkel-Umschaltung; ändert keinen Testzustand (FR-THEME-003). */
export function ThemeToggle() {
  const theme = useAppStore((state) => state.theme);
  const setTheme = useAppStore((state) => state.setTheme);

  const isDark =
    theme === 'dark' ||
    (theme === 'system' &&
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-color-scheme: dark)').matches);

  const Icon = isDark ? Sun : Moon;
  const label = isDark ? 'Hell' : 'Dunkel';

  return (
    <button
      type="button"
      className="theme-toggle no-print"
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      aria-pressed={isDark}
      aria-label={isDark ? 'Heller Modus' : 'Dunkler Modus'}
    >
      <Icon className="theme-toggle__icon" aria-hidden="true" />
      <span aria-hidden="true">{label}</span>
    </button>
  );
}
